import footballData from "../../data/footballData";
import ServiceHero from "../../components/ServiceHero/ServiceHero";
import ServiceOverview from "../../components/ServiceOverview/ServiceOverview";
import ServiceBenefits from "../../components/ServiceBenefits/ServiceBenefits";
import ConstructionProcess from "../../components/ConstructionProcess/ConstructionProcess";
import TechnicalSpecs from "../../components/TechnicalSpecs/TechnicalSpecs";
import ServiceGallery from "../../components/ServiceGallery/ServiceGallery";
import WhyChooseService from "../../components/WhyChooseService/WhyChooseService";
import ServiceFAQ from "../../components/ServiceFAQ/ServiceFAQ";
import RelatedServices from "../../components/RelatedServices/RelatedServices";
import ServiceCTA from "../../components/ServiceCTA/ServiceCTA";

const Footballfield = () => {
  return (
    <>
      <ServiceHero data={footballData} />

      <ServiceOverview data={footballData} />

      <ServiceBenefits data={footballData} />

      <ConstructionProcess />

      <TechnicalSpecs data={footballData} />

      <ServiceGallery data={footballData} />

      <WhyChooseService data={footballData} />

      <ServiceFAQ faqs={footballData.faqs} />

      <RelatedServices data={footballData} />

      <ServiceCTA data={footballData} />
    </>
  );
};

export default Footballfield;
